import { createContext, useContext } from "react";
import { CreateCategoryModalContentsProps } from "@kaltura/mediaspace-shared-create-category-modal";

export const ChannelsContext = createContext<{
    pageSize: number;
    subscribeUrl?: string;
    unsubscribeUrl?: string;
    allowCreateChannel: boolean;
    createChannelModalProps?: CreateCategoryModalContentsProps;
    searchUrl: string;
}>({
    pageSize: 20,
    subscribeUrl: "",
    unsubscribeUrl: "",
    allowCreateChannel: false,
    searchUrl: "",
});

export const useChannelsContext = () => {
    return useContext(ChannelsContext);
};
